import React from 'react'
import { removeBot } from "../battle/connection/firebase-rooms";


class RemoveBotButton extends React.Component {

  handleClick(e) {
    e.preventDefault();
    removeBot(this.props.combatantId);
  }

  render() {
    /* eslint jsx-a11y/href-no-hash: "off" */
    return (
      <a
        href="#"
        className="button extra-small remove-theme"
        onClick={this.handleClick.bind(this)}
      >
        <span className="button--text">Remove</span>
      </a>
    );
  }
}

RemoveBotButton.propTypes = {
  /*someRequiredProp: React.PropTypes.string.isRequired*/
};


export default RemoveBotButton;


// WEBPACK FOOTER //
// ./src/b5-home/RemoveBotButton.js